module.exports = __webpack_public_path__ + "static/media/patient-story-avatar-susan.4164007b.svg";